import { useNavigate, useSearchParams } from 'react-router-dom';
import PaymentFormModal from '@/components/feature/PaymentFormModal';

export default function NewPaymentPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerId') || undefined;
  const saleId = searchParams.get('saleId') || undefined;

  const handleClose = () => navigate('/payments');

  return (
    <PaymentFormModal
      open={true}
      onClose={handleClose}
      mode={customerId ? 'customer' : saleId ? 'sale' : 'general'}
      customerId={customerId}
      saleId={saleId}
      asPage
      onPaymentCreated={() => navigate('/payments')}
    />
  );
}